// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const Logo = (config: any) => ({
   replace: true,

   scope: {
      size: '@'
   },

   link(scope: any) {
      const {
         assets
      } = config.data
      scope.homeUrl = assets.home
      scope.title = assets.title
      switch (scope.size) {
         case 'small':
            scope.logoSource = assets.logoSmall
            scope.logoWidth = assets.logoSmallWidth
            scope.logoHeight = assets.logoSmallHeight
            break
         case 'large':
            scope.logoSource = assets.logoLarge
            scope.logoWidth = assets.logoLargeWidth
            scope.logoHeight = assets.logoLargeHeight
            break
         default:
            scope.logoSource = ''
      }
       scope.logoStyle = {
           '--logo-width': scope.logoWidth ? scope.logoWidth + 'px' : undefined,
           '--logo-height': scope.logoHeight ? scope.logoHeight + 'px' : undefined
       }
   },

   template: '<div><a ng-href="{{ ::homeUrl }}"><img class="logo logo-{{ ::size }}  img-responsive " ng-src="{{ ::logoSource }}" ng-style="logoStyle" alt="{{ ::title }}"></a></div>'
})

angular.module('summonApp.directives')
   .directive('logo', ['configService', Logo])
